/**
 * API Configuration
 * Update these endpoints to match your backend API
 */

const ENV = "development";

const BASE_URLS: Record<string, string> = {
  // domain: "http://192.168.1.81:5000",
  // development: "http://192.168.1.81:5000/api",
  // production: "https://pactivatebackend.packtivate.io/api",

  domain: "https://backend.whitebench.co",
  development: "https://backend.whitebench.co/api",
  production: "https://backend.whitebench.co/api",
};

// During local Vite development, use the same-origin proxy. This lets the
// browser store and send the HttpOnly refresh cookie on localhost instead of
// treating the API host as a cross-site request.

export const API_CONFIG = {
  domain: BASE_URLS["domain"],
  baseUrl: BASE_URLS[ENV],
  endpoints: {
    auth: {
      login: "/pharma/auth/login-with-pass",
      signup: "/pharma/onboarding-form",
      forgotpassword_req_otp: "/pharma/auth/forgot-password/request-otp",
      forgotpassword_verifyotp: "/pharma/auth/forgot-password/verify-otp",
      forgotpassword: "/pharma/auth/forgot-password/reset",
      resetpassword: "/pharma/auth/change-password",
      refresh: "/pharma/auth/refresh-token",
      logout: "/pharma/auth/logout",
      verifyMfa: "/pharma/auth/2fa/verify-login",
      enableMfa: "/pharma/auth/2fa/setup/confirm",
      disableMfa: "/pharma/auth/2fa/disable",
      sendLoginOtp: "/pharma/auth/login-otp/request",
      verifyLoginOtp: "/pharma/auth/login-otp/verify",
      verifyEmail: "/pharma/auth/verify-email",
    },
    // These legacy association workflows are retained as empty endpoints so
    // unused legacy modules cannot silently send requests to doctor APIs.
    invite: { getinvites: "" },
    dashboard: { getStats: "", programmeChart: "" },
    programme: {
      getProgrammes: "",
      createProgrammes: "",
      updateProgrammes: "",
      dropdownlist: "",
      invite: "",
      doctorDropdown: "",
      sendInvite: "",
    },
    members: {
      getstatdata: "",
      addmembers: "",
      uploadmembers: "",
      listMemebers: "",
      memberDetails: "",
      inviteMemebers: "",
      memberRequests: "",
      updateRequest: "",
      deleteRequest: "",
      resendRequest: "",
    },
    attendance: {
      getprogrammedata: "",
      attendanceList: "",
      updateStatus: "",
      attendanceOtp: "",
      verifyAttendanceOtp: "",
    },
    user: {
      getProfileData: "/pharma/profile",
      updateProfile: "/pharma/update-profile",
      passwordReset: "/pharma/auth/forgot-password/reset",
      passwordResetReqOtp: "/pharma/auth/forgot-password/request-otp",
      passwordResetVerifyOtp: "/pharma/auth/forgot-password/verify-otp",
      setupMfa: "/pharma/auth/2fa/setup",
      confirmMfa: "/pharma/auth/2fa/setup/confirm",
      cancelMfa: "/pharma/auth/2fa/disable",
      vertifyphonerequestotp: "/pharma/update-profile/phone/request",
      vertifyphoneverifyotp: "/pharma/update-profile/phone/verify",
      vertifyEmailRequestOtp: "/pharma/auth/verify-email",
      updateNotification: "",
    },
    bank: {
      accounts: "/pharma/bank-accounts",
      setPrimary: "/pharma/bank-accounts/:bank_account_id/set-primary",
      updateStatus: "/pharma/bank-accounts/:bank_account_id/update-status",
    },
    kyc: {
      documents: "/pharma/kyc/documents",
      details: "/pharma/kyc/details",
    },
    creation: {
      engagementRequest: "/pharma/engagement/create",
    },
    engagement: {
      list: "/pharma/engagement/list",
      details: "/pharma/engagement/:engagement_id/details",
      updateStatus: "/pharma/engagement/:engagement_id/status",
      doctors: "/pharma/engagement/doctors",
      inviteDoctors: "/pharma/engagement/:engagement_id/invite-doctors",
      invitationAction:
        "/pharma/engagement/:engagement_id/doctors/:invitation_id/invitation-action",
      cmeRequests: "/pharma/cme-requests",
    },
    doctors: {
      find: "/pharma/doctors/find-doctors",
      shortlist: "/pharma/doctors/shortlist",
      removeShortlisted: "/pharma/doctors/remove-shortlisted/:doctor_id",
      specialtyList: "/pharma/doctors/specialty-list",
    },
    events: {
      create: "/pharma/events/create",
      update: "/pharma/events/update/:event_id",
      list: "/pharma/events/list",
    },

    bankAccounts: {
      list: "/doctors/bank-accounts",
      add: "/doctors/bank-accounts",
      setPrimary: "/doctors/bank-accounts/:bank_account_id/set-primary",
      updateStatus: "/doctors/bank-accounts/:bank_account_id/update-status",
    },
  },
};

/**
 * Get full API URL
 */
export const getApiUrl = (endpoint: string): string => {
  const baseUrl = API_CONFIG.baseUrl.replace(/\/$/, "");
  const path = endpoint.replace(/^\//, "");

  return `${baseUrl}/${path}`;
};

/**
 * Replace URL parameters
 */
export const replaceUrlParams = (
  url: string,
  params: Record<string, string>,
): string => {
  let result = url;
  Object.entries(params).forEach(([key, value]) => {
    result = result.replace(`:${key}`, encodeURIComponent(value));
  });
  return result;
};
